import { Injectable, NgZone } from '@angular/core';
import { getUniqueId } from '@seu-helpers';
import { SeuToast, SeuToastFull } from '@seu-types';
import { BehaviorSubject, Observable, filter } from 'rxjs';

const NOTIFICATION_TIMEOUT = 7000;

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toasts$$ = new BehaviorSubject<SeuToastFull[]>([]);

  constructor(private zone: NgZone) {}

  get toasts$(): Observable<SeuToastFull[]> {
    return this.toasts$$.pipe(
      filter(
        (toasts): toasts is SeuToastFull[] => typeof toasts !== 'undefined'
      )
    );
  }

  public addToast(toast: SeuToast): void {
    this.zone.run(() => {
      const toastFull = {
        ...toast,
        id: getUniqueId(),
      };
      const toasts = this.toasts$$.getValue();
      this.toasts$$.next([...toasts, toastFull]);

      setTimeout(() => {
        const toasts = this.toasts$$
          .getValue()
          .filter((n) => n.id !== toastFull.id);

        this.toasts$$.next(toasts);
      }, NOTIFICATION_TIMEOUT);
    });
  }

  public deleteToast(id: string): void {
    const toasts = this.toasts$$.getValue().filter((n) => n.id !== id);

    this.toasts$$.next(toasts);
  }
}
